import { theme } from 'antd';
import { DeletedFilled } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import React, { useState } from 'react';
import { DeleteCategoryModal } from 'zComponents/molecules';
import { Button, Dropdown, Flex } from 'zui/Antd';

const ManageCategoryDropdown = ({ categoryID }) => {
	// ✅ Hooks
	const {
		token: { colorBgContainer, boxShadow, borderRadiusLG, paddingSM, fontWeightStrong }
	} = theme.useToken();

	// ✅ Permissions
	const canDeleteCategory = useManagePermittedRoles('deleteCategory');

	// ✅ Local State
	const [openDropdown, setOpenDropdown] = useState(false);

	const items = [
		{
			key: 'deleteCategory',
			label: (
				<DeleteCategoryModal categoryIDs={[categoryID]}>
					<Button
						type='text'
						danger
						icon={<DeletedFilled width={16} height={16} color='currentColor' />}
						block
						disabled={!canDeleteCategory}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
					>
						Delete Category
					</Button>
				</DeleteCategoryModal>
			)
		}
	];

	return (
		<>
			<Dropdown
				openClassName='dropdown-open'
				trigger={['click']}
				placement='bottomRight'
				open={openDropdown}
				onOpenChange={(visible) => setOpenDropdown(visible)}
				dropdownRender={() => (
					<Flex
						style={{
							backgroundColor: colorBgContainer,
							borderRadius: borderRadiusLG,
							width: 240,
							boxShadow: boxShadow,
							padding: paddingSM
						}}
						vertical
						gap={paddingSM}
					>
						{items.map((item) => (
							<div key={item.key} onClick={() => setOpenDropdown(false)}>
								{item.label}
							</div>
						))}
					</Flex>
				)}
			>
				<Button type='primary'>Manage Category</Button>
			</Dropdown>
		</>
	);
};

export default ManageCategoryDropdown;
